import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showRestoreButton && _vm.canSeeActionButtons)?_c(VBtn,{attrs:{"disabled":_vm.loading,"color":"primary","large":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',[_vm._v(_vm._s(_vm.$t("WorkspaceEdit.restoreButton")))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }